"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssClassNames = {
    loaded: 'ng-lazyloaded',
    loading: 'ng-lazyloading',
    failed: 'ng-failed-lazyloaded',
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-lazyload-image/src/constants.js
// module id = 727
// module chunks = 1